// storageDuration filter
//
//    {{ vm.account.storage_duration_days | storageDuration }}

angular.module('app.filters').filter('storageDuration', ($filter) => {
  'ngInject';
  return (durationDays) => {
    const days = parseInt(durationDays, 10);
    switch (days) {
      case 365:
        return '1 year';
        break;
      case 731:
        return '2 years';
        break;
      case 1096:
        return '3 years';
        break;
      case 1461:
        return '4 years';
        break;
      case 1826:
        return '5 years';
        break;
      default:
        return `${durationDays} days`;
        break;
    }
  };
});



// WEBPACK FOOTER //
// ./app/filters/storage-duration.js